import * as React from 'react'
import {ResultFile} from '../../repository/NatGetAssocWorkReportPlanResults'
import styled from 'styled-components'
import {Colors, FontFamily, FontSize} from '../../../../../styledComponents/Constants'
import {
    BlockSpacerPcOnly,
    BlockSpacerSpOnly,
    currentMedia,
    HideInPC
} from '../../../../../styledComponents/ResponsiveConvenience'
import { Box } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {getLinkIconComponent, IconBox} from '../../../../../components/assocDirector/AssocDirectorCommon'
import {getFileExtension} from '../../../../common/util/Natutil'
import {FullWidthColumnFlexContainer, RowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {StyledLink} from '../../../../../styledComponents/residentPage/Links'

interface Props {
    resultFiles: ResultFile[]
}

export const NatNextTermReport: React.FC<Props> = props => {
    return (
        <WideWhiteArea>
            <HideInPC>
                <Box height={'10px'}/>
                <Box fontSize={FontSize.Small}>※ファイルサイズが大きい場合は、Wi-Fi環境下での閲覧を推奨します。</Box>
            </HideInPC>
            <BlockSpacerSpOnly height={'20px'}/>
            <BlockSpacerPcOnly height={'15px'}/>
            {props.resultFiles.map((resultFile, key) => {
                return (
                    <>
                        <DocumentLink to={resultFile.path} key={key}>
                            <FileContainer>
                                <HideInPC>
                                    <FileIconBox>
                                        {getLinkIconComponent(getFileExtension(resultFile.publishMaterialName))}
                                    </FileIconBox>
                                </HideInPC>
                                <FileNameContainer>
                                    <AbbreviateWhenUnseen>{resultFile.publishMaterialName}</AbbreviateWhenUnseen>
                                    <HideInPC>
                                        <Box fontSize={FontSize.Small} color={Colors.AccentDark}>
                                            {resultFile.fileSizeKB}KB
                                        </Box>
                                    </HideInPC>
                                </FileNameContainer>
                            </FileContainer>
                        </DocumentLink>
                        <BlockSpacerSpOnly height={'5px'}/>
                        <BlockSpacerPcOnly height={'10px'}/>
                    </>
                )
            })}
            <BlockSpacerSpOnly height={'15px'}/>
            <BlockSpacerPcOnly height={'10px'}/>
        </WideWhiteArea>
    )
}

const WideWhiteArea = styled.div`
  background-color: ${Colors.Surface};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  padding: 0 15px;
  box-sizing: border-box;
  overflow: hidden;
`

const FileIconBox = styled(IconBox)`
  color: ${Colors.AccentDark};
`

const FileContainer = styled(RowFlexContainer)`
  width: 100%;
  font-family: ${FontFamily.ResidentDefault};
  overflow-wrap: anywhere;
  ${currentMedia.lessThan('sp')`
     padding: 0px 10px;
     border: 1px solid ${Colors.AccentLight};
     border-radius: 4px;
  `};
`

const FileNameContainer = styled(FullWidthColumnFlexContainer)`
  align-items: flex-start;
  ${currentMedia.lessThan('sp')`
     color: ${Colors.Body};
     margin-left: 5px;
     overflow: hidden;
     padding: 10px 0;
  `};
`

const DocumentLink = withStyles({
    root: {
        color: Colors.Primary,
        fontSize: FontSize.Body,
        lineHeight: 1.5,
    }
})(StyledLink)

const AbbreviateWhenUnseen = styled.div`
  width: 100%;
  ${currentMedia.lessThan('sp')`
     overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
     color: ${Colors.Body};
  `};
`